"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  stroke: ${({ theme, color }) => color || theme.palette.gray[70]};
`;
const RestartIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, color, ...rest }) => ((0, jsx_runtime_1.jsxs)("svg", { fill: "none", height: size, viewBox: "0 0 16 16", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPath, { color: color, d: "M15 2.39774V6.59843H10.7993", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }), (0, jsx_runtime_1.jsx)(StyledPath, { color: color, d: "M13.2427 10.099C12.3078 12.7453 9.73534 14.4542 6.93355 14.2903C4.13175 14.1264 1.77613 12.1292 1.15615 9.39193C0.536174 6.65468 1.80133 3.83736 4.25906 2.48219C6.71679 1.12702 9.77453 1.56074 11.7585 3.54592L15 6.59843", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" })] }));
exports.default = (0, IconContainer_1.default)(RestartIcon);
//# sourceMappingURL=index.js.map